import { Utils } from '@genial/utils';
import { useState } from 'react';

import {
  AssetDefaultOrSelectedTypeMap,
  SubmitUpdateProps,
} from '../../../../../../../store/product/types';

export const useFixedIncomeSellAssetController = (
  offer: AssetDefaultOrSelectedTypeMap['fixedIncomeSell'],
  submitUpdate?: (data: SubmitUpdateProps) => Promise<boolean>
) => {
  const calcNetFinancialValue = (currentQuantity: number) => {
    return currentQuantity * offer.unitaryPriceNormalized - offer.irNormalized;
  };

  const defaultQuantity = offer.orderQuantity || offer.availableAmount || 0;
  const defaultNetFinancialValue = offer.orderQuantity
    ? calcNetFinancialValue(offer.orderQuantity)
    : offer.netFinancialValue;

  const [amountItem, setAmountItem] = useState(defaultQuantity);
  const [netFinancialValue, setNetFinancialValue] = useState(defaultNetFinancialValue);

  const handleChangeAmountItem = async (value: number) => {
    const updateFormValues = () => {
      setAmountItem(value);
      setNetFinancialValue(calcNetFinancialValue(value));
    };

    if (submitUpdate) {
      const response = await submitUpdate({ amount: value });
      if (response) {
        updateFormValues();
      }
    } else {
      updateFormValues();
    }
  };

  const netFinancialValueIsNegative = netFinancialValue < 0;
  const quantityIsInvalid = amountItem <= 0 || amountItem > offer.availableAmount;

  const hasError = netFinancialValueIsNegative || quantityIsInvalid;

  const errorMessage = netFinancialValueIsNegative
    ? 'Valor líquido negativo'
    : quantityIsInvalid
    ? 'Quantidade inválida.'
    : '';

  return {
    amountItem,
    hasError,
    errorMessage,
    netFinancialValue,
    netFinancialValueFormatted: Utils.Mask.Money(netFinancialValue),
    handleChangeAmountItem,
  };
};

export type FixedIncomeAssetController = ReturnType<typeof useFixedIncomeSellAssetController>;
